import { createAction } from '@'
import FetchMappingCoverage from './FetchMappingCoverage'
import { $supplierCoverage, $supplierCoverageLoading, $supplierCoverageQuery } from '../stores'

const GetSupplierCoverage = createAction('GetSupplierCoverage', async params => {
    const query = {
        column: `${params.column}`.trim(),
        page: params.page || 1,
        page_size: params.page_size || 20
    }
    const isLatest = () => $supplierCoverageQuery.getState() === query

    $supplierCoverageQuery.setState(() => query)
    $supplierCoverageLoading.setState(() => true)
    try {
        const data = await FetchMappingCoverage({ method: 'GET', path: '/supplier', params: query }, { silent: true })
        if (isLatest()) {
            $supplierCoverage.setState(() => data)
        }
    } catch (e) {
        // An unknown column is answered 400 with a readable message — show it.
        if (isLatest()) {
            $supplierCoverage.setState(() => e.data || { success: false, message: e.message })
        }
    } finally {
        if (isLatest()) {
            $supplierCoverageLoading.setState(() => false)
        }
    }
})

export default GetSupplierCoverage
